// src/config.js

export const BASE_NETWORK = {
  chainId: '0x2105', // 8453 in hex
  chainIdDecimal: 8453,
  chainName: 'Base',
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: ['https://mainnet.base.org'],
  blockExplorerUrls: ['https://basescan.org'],
};

// Token configuration
export const BESTCRYPTOTWITS_TOKEN = {
  address: '0xFf58390EcB663e0e34e49382e0836d057789480D',
  symbol: 'BESTCRYPTOTWITS',
  decimals: 18,
  name: 'BestCryptoTwits',
};

// Uniswap V4 on Base
export const SWAP_CONFIG = {
  poolManagerAddress: '0x7Da1D65F8B249183667cdE74C5CBD46dD38AA829',
  swapRouterAddress: '0x94cC0AaC535CCDB3C01d6787D6413C739ae12bc4',
  wethAddress: '0x4200000000000000000000000000000000000006',
  feePercentage: 0.3,
};

// Staking configuration
export const STAKING_CONFIG = {
  contractAddress: '0x53Fa2aA85650ab58400b69d15a2432f954fD2b58',
  rewardRate: 7,
  minStakeDuration: 86400,
};